// extracted by mini-css-extract-plugin
module.exports = {"container":"swish_container__SrXQC","article":"swish_article__pwaSo","campaign":"swish_campaign__bSfsR"};